import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, type OnInit, type OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { zoomIn } from 'ng-animate';
import * as bootstrap from 'bootstrap';


import { DeviceService } from 'src/app/services/devices/device.service';
import { TimeFilter, UtilsService } from 'src/app/services/utils/utils.service';

import * as XLSX from 'xlsx';

@Component({
    selector: 'app-costs',
    templateUrl: './costs.component.html',
    styleUrls: ['./costs.component.scss'],
    standalone: false
})
export class CostsComponent implements OnInit {
  @Input() dataGroup: any;

  op = 1;
  selectedSubgroupIds: string[] = [];
  duplicatedDevices: string[] = [];
  duplicateModal?: bootstrap.Modal;
  showModalHistorics: boolean = false;
  dataHistoric: any[] = [];


  subgroups: any[] = [];
  allChargers: any[] = [];
  selectedChargerIds: string[] = [];

  dataAnalytics : any[] = [];
  connectors : any[] = []
  zoomIn : any
  name = '';
  serial = '';
  showModal = false;

  selectedMonthLabel: string | null = null;

  // Filtros
  activeFilter: TimeFilter = 'today';
  customStartDate;
  customEndDate;
  priceKwh = 0.00;
  showColumnDropdown = false;
  selectedColumn: string | null = null;
  tableSearchText = '';
  filterableColumns = [
    'name',
    'serial',
    'start_datetime',
    'end_datetime',
    'user',
    'element',
  ];
  columnDisplayNames: { [key: string]: string } = {
    name: 'Nombre',
    serial: 'Serial',
    start_datetime: 'Fecha inicio',
    end_datetime: 'Fecha fin',
    user: 'Usuario',
    element: 'Conector',
  };
  searchFilteredCharges: any[] = [];

  // Vista
  currentView: 'list' | 'grid' = 'list';

  // Acordeones
  subgroupsExpanded = false;
  chargersExpanded = false;

  // Resumen
  showSummary = false;
  summaryData = {
    selectedCount: 0,
    totalConsumption: 0,
    estimatedCost: 0,
  };
  // Cargas filtradas
  dataRecargas: any[] = [];
  filteredCharges: any[] = [];
  filteredChargesInitial: any[] = [];

  // paginación
  currentPage = 1;
  itemsPerPage = 10;
  goToPageInput: number = this.currentPage;

  // Ordenación
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  total: any;

  constructor(  private _devices: DeviceService, private _router: Router, private _utils : UtilsService ) {}

  async ngOnInit(): Promise<void> {

    if (this.dataGroup && Object.keys(this.dataGroup).length > 0) {
      localStorage.setItem('dataCosts', JSON.stringify(this.dataGroup));
    } else {
      const storedData = localStorage.getItem('dataCosts');
      if (storedData) {
        this.dataGroup = JSON.parse(storedData);
      } else {
        console.error('No data found in localStorage for dataCosts');
        return;
      }
    }

    const stored = localStorage.getItem('priceKwh');

    if (stored) {
      const precios: { groupName: string; priceKwh: number }[] =
        JSON.parse(stored);

      const found = precios.find(
        (element) => element.groupName === this.dataGroup.name
      );
      if (found) {
        this.priceKwh = found.priceKwh;
      } else {
        // Si el grupo actual no está en la lista, lo añadimos con precio 0
        precios.push({ groupName: this.dataGroup.name, priceKwh: 0.00 });
        localStorage.setItem('priceKwh', JSON.stringify(precios));
        this.priceKwh = 0;
      }
    } else {
      // No existe ningún registro en localStorage, creamos uno nuevo con el grupo actual
      const nuevosPrecios = [{ groupName: this.dataGroup.name, priceKwh: 0 }];
      localStorage.setItem('priceKwh', JSON.stringify(nuevosPrecios));
      this.priceKwh = 0;
    }

    await this.getHistoric();
    await this.sortArrayByName (this.dataGroup.devices, 'name');

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - 7);

    this.customStartDate = pastDate.toISOString().split('T')[0];
    this.customEndDate = today.toISOString().split('T')[0];


    this.subgroups = this.dataGroup.subgroups || [];
    if (this.subgroups?.length > 0)
      this.loadInfoSubgroups()

    this.allChargers = this.dataGroup.devices || [];
    // console.log('todos los cargadores', this.allChargers);
    // console.log( 'historico de cargadores',   this.dataGroup.devices[0].historic[0]?.active  );

    this.dataRecargas = [];

    this.allChargers.forEach((charger) => {
      const historics = charger.historic || [];

      historics.forEach((hist) => {
        this.dataRecargas.push({
          ...hist,
          serial: charger.serial,
          name: charger.name,
        });
      });
    });

    this.onFilterChange(this.activeFilter);

    this.selectedChargerIds = this.allChargers
      .map((charger) => charger.serial)
      .filter((id): id is string => id !== undefined);

    this.dataRecargas = [];

    this.allChargers.forEach((charger) => {
      const historics = charger.historic || [];

      historics.forEach((hist) => {
        this.dataRecargas.push({
          ...hist,
          serial: charger.serial,
          name: charger.name,
        });
      });
    });

    // this.summaryData.selectedCount = this.selectedChargerIds.length;
    this.updateFilteredCharges();


  }

  get equivalentTrees(): number {
    const kgCO2 = this.summaryData.estimatedCost * 0.33999986;
    const trees = kgCO2 / 20;
    return Math.max(1, Math.floor(trees)); // al menos 1, sin decimales
  }

  getHistoric() {
  return new Promise((resolve) => {
      const historicPromises = this.dataGroup.devices.map(device => {
          return new Promise<void>((resolveDevice) => {
              // Hacer dos llamadas: obtener históricos y obtener información del dispositivo
              Promise.all([
                  this._devices.getHistorics(device.serial).toPromise(),
              ]).then(([historicDataResponse]) => {

                  const historicData = historicDataResponse.historic || [];
                  // let total = historicData.reduce((acc, element) => acc + element.active, 0);

                  // this.lastChargers.push({ serial: device.serial, historics: historicData });

                  const deviceIndex = this.dataGroup.devices.findIndex(d => d.serial === device.serial);
                  if (deviceIndex !== -1) {
                      this.dataGroup.devices[deviceIndex] = {
                          ...device,
                          historic: historicData,
                          // total: total
                      };
                  }

                  // this.total += total;
                  resolveDevice();
              }).catch(error => {
                  console.error('Error obteniendo históricos o información del dispositivo:', error);
                  resolveDevice(); // Continuar con los demás dispositivos aunque haya fallos
              });
          });
      });
      Promise.all(historicPromises).then(() => {
          resolve(true);
          this.dataGroup.devices.forEach(device => {
              // this.selectedDevices.push({ check: false, serial: device.serial });
          });
          // this.lastFiveCharges = this.getLastFiveCharges();
      });
  });
  }

  sortArrayByName(array, key) {
    return array.sort((a, b) => {
        const valorA = key.split('.').reduce((o, k) => (o?.[k] ?? ""), a).toString().toLowerCase();
        const valorB = key.split('.').reduce((o, k) => (o?.[k] ?? ""), b).toString().toLowerCase();
        return valorA.localeCompare(valorB);
    });
  }

  // Gestión de filtros
  onFilterChange(filterType): void {
    this.activeFilter = filterType;
    this.updateFilteredCharges();
  }

  onCustomDateChange(event?: { startDate: string; endDate: string }): void {
    if (event) {
      this.customStartDate = event.startDate;
      this.customEndDate = event.endDate;
    }
    if (this.activeFilter === 'custom') {
      this.updateFilteredCharges();
    }
  }

  // Gestión de vista
  onViewChange(viewType): void {
    this.currentView = viewType;
  }

  // Gestión de acordeones
  toggleAccordion(section: 'subgroups' | 'chargers'): void {
    if (section === 'subgroups') {
      this.subgroupsExpanded = !this.subgroupsExpanded;
    } else {
      this.chargersExpanded = !this.chargersExpanded;
    }
  }

  // Gestión de selección
  onChargerSelectionChange(event: Event, chargerId: string): void {
    const input = event.target as HTMLInputElement;
    const selected = input.checked;

    if (selected) {
      this.selectedChargerIds = [...this.selectedChargerIds, chargerId];
    } else {
      this.selectedChargerIds = this.selectedChargerIds.filter(
        (id) => id !== chargerId
      );
    }

    this.updateFilteredCharges();
  }

  onSelectAllChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selectAll = input.checked;

    if (selectAll) {
      this.selectedChargerIds = this.allChargers
        .map((charger) => charger.serial)
        .filter((id): id is string => id !== undefined);
    } else {
      this.selectedChargerIds = [];
    }
    this.updateFilteredCharges();
  }

  isChargerSelected(chargerId: string): boolean {
    return this.selectedChargerIds.includes(chargerId);
  }

  get isAllSelected(): boolean {
    return this.selectedChargerIds.length === this.allChargers.length;
  }

  get isIndeterminate(): boolean {
    return (
      this.selectedChargerIds.length > 0 &&
      this.selectedChargerIds.length < this.allChargers.length
    );
  }

  // Actualización de resumen
  updateSummary(): void {
    const selectedCount = this.selectedChargerIds.length;
    this.showSummary = selectedCount > 0;

    if (!this.showSummary) {
      // Reinicia a cero si no hay selección
      this.summaryData = { selectedCount: 0, totalConsumption: 0, estimatedCost: 0 };
      return;
    }

    const chargesToSum = this.filteredCharges;
    let totalEnergy = 0;

    chargesToSum.forEach(ch => totalEnergy += ch.active);

    this.summaryData = {
      selectedCount,
      totalConsumption: totalEnergy / 1000,
      estimatedCost: (totalEnergy / 1000) * this.priceKwh,
    };
  }



  private updateFilteredCharges(): void {
    // if (this.dataRecargas.length === 0) {
    //   this.filteredCharges = [];
    //   return;
    // }

    const { from: fromDate, to: toDate } = this._utils.resolveDateRange(this.activeFilter, this.customStartDate, this.customEndDate);

    // Filtrado combinado
    this.filteredCharges = this.dataRecargas.filter((item) => {
      const itemDate = new Date(item.start_datetime);
      const isInDateRange = itemDate >= fromDate && itemDate <= toDate;

      const isChargerSelected =
        this.selectedChargerIds.length > 0 &&
        this.selectedChargerIds.includes(item.serial);

      return isInDateRange && isChargerSelected;
    });
    this.filteredChargesInitial = this.filteredCharges;

    this.updateSummary();

  }

  goToDevice(serial) {}

  // Acciones

  onExportData(format: 'csv' | 'xls' | 'xml') {
    const data = this.filteredCharges.map((charge) => ({
      Name: charge.name || '',
      Serial: charge.serial || '',
      'Fecha inicio': charge.start_datetime,
      'Fecha fin': charge.end_datetime,
      Duración: this.subtractDates(charge.end_datetime, charge.start_datetime),
      Energía: charge.active,
      Coste: ((charge.active / 1000) * this.priceKwh).toFixed(2),
      User: charge.user || '',
      Conector: 'Connector' + this.mennekes(charge.element) || '',
    }));

    if (format === 'csv' || format === 'xls') {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');
      const extension = format === 'csv' ? 'csv' : 'xlsx';
      XLSX.writeFile(workbook, `cargas.${extension}`, { bookType: extension });
    } else if (format === 'xml') {
      const xmlData = this.convertToXML(data);
      const blob = new Blob([xmlData], { type: 'application/xml' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'cargas.xml';
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  private convertToXML(data: any[]): string {
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<cargas>\n';
    for (const item of data) {
      xml += '  <carga>\n';
      for (const key in item) {
        const tag = this.toXmlTagName(key);
        xml += `    <${tag}>${this.escapeXml(item[key])}</${tag}>\n`;
      }
      xml += '  </carga>\n';
    }
    xml += '</cargas>\n';
    return xml;
  }

  // Los nombres de elemento XML no admiten espacios ni pueden empezar por dígito
  private toXmlTagName(key: string): string {
    const tag = key.trim().replace(/\s+/g, '_').replace(/[^\p{L}\p{N}_.-]/gu, '');
    return /^[\p{L}_]/u.test(tag) ? tag : `_${tag}`;
  }

  private escapeXml(value: any): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  // Utilidades
  getStatusClass(status): string {
    switch (status) {
      case 1:
        return 'status-active';
      case 0:
        return 'status-inactive';
      default:
        return '';
    }
  }

  getStatusText(status): string {
    switch (status) {
      case 1:
        return 'online';
      case 0:
        return 'offline';
      default:
        return status + ' Desconocido';
    }
  }

  subtractDates(date1, date2) {
    var difference_ms = new Date(date1).getTime() - new Date(date2).getTime();
    //take out milliseconds
    difference_ms = difference_ms / 1000;
    var seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var hours = Math.floor(difference_ms % 24);
    if (hours != 0)
      return (
        hours + 'h ' + minutes.toString() + 'm ' + seconds.toString() + 's'
      );
    else return minutes.toString() + 'm ' + seconds.toString() + 's';
  }

  // Ordenación
  onSort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredCharges.sort((a: any, b: any) => {
      const valueA = a[column];
      const valueB = b[column];

      if (valueA == null) return 1;
      if (valueB == null) return -1;

      const result = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      return this.sortDirection === 'asc' ? result : -result;
    });

    // this.updatePaginatedCharges(); // si paginas los datos
  }

  get paginatedCharges() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredCharges.slice(startIndex, endIndex);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredCharges.length / this.itemsPerPage);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.goToPageInput = page;
    }
  }

  onItemsPerPageChange(newSize: string): void {
    this.itemsPerPage = parseInt(newSize, 10);
    this.currentPage = 1; // Reiniciar a la primera página
  }

  get visiblePageButtons(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const pagesToShow = 2;
    const pages: (number | string)[] = [];

    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);

      if (current > pagesToShow + 2) pages.push('left-ellipsis');

      const start = Math.max(2, current - pagesToShow);
      const end = Math.min(total - 1, current + pagesToShow);
      for (let i = start; i <= end; i++) pages.push(i);

      if (current < total - (pagesToShow + 1)) pages.push('right-ellipsis');

      pages.push(total);
    }

    return pages;
  }

  onPageClick(page: number | string): void {
    if (typeof page === 'number') {
      this.goToPage(page);
    }
  }

  onGoToPageInputChange(): void {
    const page = Number(this.goToPageInput);
    if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
      this.goToPage(page);
    } else {
      // opcional: feedback si el valor es inválido
      this.goToPageInput = this.currentPage;
    }
  }

  isNumber(value: any): value is number {
    return typeof value === 'number';
  }

  toggleColumnDropdown() {
    this.showColumnDropdown = !this.showColumnDropdown;
  }

  selectColumn(column: string) {
    this.selectedColumn = column;
    this.showColumnDropdown = false;
    this.tableSearchText = ''; // limpia el texto al cambiar de campo
    this.applyTableFilter(); // limpia los resultados también
  }

  applyTableFilter() {
    const search = this.tableSearchText.toLowerCase();

    if (!this.selectedColumn) {
      // Si no hay columna seleccionada, usamos los datos ya filtrados
      this.searchFilteredCharges = [...this.filteredChargesInitial];
    } else {
      this.searchFilteredCharges = this.filteredChargesInitial.filter(
        (item) => {
          const field = item[this.selectedColumn!];
          return field && field.toString().toLowerCase().includes(search);
        }
      );
    }

    this.currentPage = 1;
    this.updateSummary();
  }

  savePrice(): void {
    const stored = localStorage.getItem('priceKwh');
    const groupName = this.dataGroup.name;

    let precios: { groupName: string; priceKwh: number }[] = [];

    if (stored) {
      try {
        precios = JSON.parse(stored);
      } catch (e) {
        console.error('Error al parsear priceKwh desde localStorage:', e);
        precios = [];
      }
    }

    const existing = precios.find((item) => item.groupName === groupName);

    if (existing) {
      existing.priceKwh = this.priceKwh;
    } else {
      precios.push({ groupName, priceKwh: this.priceKwh });
    }

    localStorage.setItem('priceKwh', JSON.stringify(precios));
  }

  loadInfoSubgroups(): void {
    let loaded = 0;
    const total = this.subgroups.length;

    this.subgroups.forEach((group) => {
      this._devices.getLinkedDevices(group.alias).subscribe({
        next: (devices) => {
          group.devices = devices;
        },
        error: (err) => {
          console.error(`❌ Error al cargar devices para ${group.alias}:`, err);
          group.devices = [];
        },
        complete: () => {
          loaded++;
          if (loaded === total) {
            this.subgroups.forEach((group) => {
              group.devices.forEach((device) => {
                this._devices.getHistorics( device.serial).subscribe( data => {
                  device.historic = data.historic || []
                  device.total = 0
                  if (device.historic && device.historic.length > 0) {
                    device.total = device.historic.reduce((acc, element) => acc + element?.active, 0);
                  }
                })
              });
            }
          );
          }
        }
      });
    });
  }


  showSubgroup(index: number): void {
    this._router.navigate([`dashboard/group/${this.subgroups[index].alias}/costs`])

    // this._devices.getGroup(this.subgroups[index].alias).subscribe(data => {
    //   console.log('data subgrupo ', data);

    //   // Asignar los subgrupos al grupo
    //   this.subgroups[index].subgroups = data.subgroups;

    //   // Continuar solo después de que se haya completado la asignación
    //   this.dataGroup = this.subgroups[index];

    //   // Re-ejecutar inicialización con el nuevo dataGroup
    //   this.ngOnInit();
    // });
  }

  getHistoricGraph(device, index){
    this.getConnectors(device);
    this._devices.getHistoricGraphView(device,
      this._utils.getFormatedLocalDate(new Date(), 'YYYY-MM-DD'),
      this._utils.getFormatedLocalDate( new Date() , 'YYYY-MM-DD'))
          .subscribe(data => {

            let filledData: any[] = [];
            for(let i=0; i<24; i++){

              let findHour = data.data.find(d=>Number.parseInt(this._utils.getFormatedLocalDate(d.hour, 'HH'))==i)
              findHour?filledData.push(findHour):filledData.push({});
            }
            this.dataAnalytics = filledData;
            this.serial = device
            this.name = this.allChargers[index].name
            this.showModal = true;
            setTimeout(() => {
              try {
              } catch (error: any) {
                console.error("%cLoad Graph Historics: ", 'background: black; color: white;', error.message);
              }
            }, 300);
          }, err => {

          });

  }

  getDataHistoric(device, startIndex){
    this._devices.getHistorics(device).subscribe(data => {
      this.dataHistoric = data.historic;
      // this.getConnectors(device);
          this._devices.getElemDevice(device)
    .subscribe(data => {
      this.connectors = data;
      this.showModalHistorics = true;
    })
    })

  }

  getConnectors(device){
    this._devices.getElemDevice(device)
    .subscribe(data => {
      this.connectors = data;
    })
  }

  mennekes(element){
    if (element === 'mennekes' || element === 'mennekes1') {
      return '1' ;
    }else if (element === 'mennekes2') {
    return  '2'
    }
    return ''
  }

  onMonthSelected(event: { startDate: string; endDate: string; monthLabel: string }): void {
    this.customStartDate = event.startDate;
    this.customEndDate = event.endDate;
    this.selectedMonthLabel = event.monthLabel;
    this.updateFilteredCharges();
  }

  isSubgroupSelected(id: string): boolean {
    return this.selectedSubgroupIds.includes(id);
  }

  onSubgroupSelectionChange(event: Event, id: string): void {
    const checked = (event.target as HTMLInputElement).checked;
    var action = 'add'

    if (checked) {
      if (!this.isSubgroupSelected(id)) {
        this.selectedSubgroupIds = [...this.selectedSubgroupIds, id];
        action = 'add';
      }
    } else {
      this.selectedSubgroupIds = this.selectedSubgroupIds.filter(x => x !== id);
      action = 'remove';
    }
    this.rebuildChargersFromSubgroups(action, id);
  }


  rebuildChargersFromSubgroups(action, grupo? ): void {
      let x: any = []
      x = this.subgroups.filter(g => grupo.includes(g.alias))
      let devicesDuplicated: any = [];
      if (action === 'add') {
      if (x[0].devices) {
        for (const d of x[0].devices) {
          // sólo se añade si no existía
          if (!this.allChargers.some(c => c.serial === d.serial)) {
            this.allChargers.push(d);
          }else
          {
            devicesDuplicated.push(d.serial);
            console.log('El cargador ya existe, no se añade de nuevo:', d.serial);
          }
        }
        if (devicesDuplicated.length > 0) {
          this.duplicatedDevices = devicesDuplicated;
          const element = document.getElementById('duplicateModal')!;
          this.duplicateModal = new bootstrap.Modal(element);
          this.duplicateModal.show();
        }
      }
    }
    if (action === 'remove') {

      /* 1️⃣  Prepara dos colecciones para buscar rápido */
      const aQuitar   = new Set( x[0].devices.map(d => d.serial) );   // del subgrupo
      const duplicado = new Set( this.duplicatedDevices );            // ya existían

      /* 2️⃣  Filtra – se elimina SOLO si está en aQuitar y NO en duplicado */
      this.allChargers = this.allChargers.filter(charger =>
        !( aQuitar.has(charger.serial) && !duplicado.has(charger.serial) )
      );
    }

    //  Seleccionar por defecto todos los cargadores
    this.selectedChargerIds = this.allChargers.map(c => c.serial);

    //  Reconstruir los historiales que usa el resumen
    this.dataRecargas = [];
    this.allChargers.forEach(ch => ch.historic?.forEach((h: any) => {
    this.dataRecargas.push({ ...h, serial: ch.serial, name: ch.name });  }));

    this.updateFilteredCharges();
  }

  toggleSubgroupDetails(i: number): void {
    this.subgroups[i].showDetails = !this.subgroups[i].showDetails;
  }


}


